//SERVER ROUTES
export const USER_SERVER = '/api/user';
export const CODE_SERVER = '/api/code';
export const ORGANIZATION_SERVER = '/api/organization';
export const POST_SERVER = '/api/post';
export const DASHBOARD_SERVER = '/api/dashboard';
export const Herbaladr_SERVER = '/api/herbaladr';
export const GUIDE_SERVER = '/api/guideline'; // 실제 라우터 경로에 맞게 수정
